import { Sprite, Texture } from 'pixi.js';

export class PopupRays extends Sprite {
  private static readonly visibleAlpha = 0.7;

  private static readonly initialScale = 1.25;

  private static readonly visibleScale = 2.25;

  constructor() {
    super(Texture.from('Ray'));
    this.anchor.set(0.5);
    this.scale.set(1);
    this.blendMode = 'add';
    this.visible = false;
    this.alpha = 0;
  }

  public update(deltaTime: number): void {
    if (!this.visible) return;
    this.rotation += deltaTime * 0.001;
  }

  public fadeIn(): void {
    if (this.alpha === 1) return;
    this.visible = true;
    this.scale.set(PopupRays.initialScale, PopupRays.initialScale);
    this.removeTweens();
    this.tweenTo(
      { alpha: PopupRays.visibleAlpha, scaleX: PopupRays.visibleScale, scaleY: PopupRays.visibleScale },
      333,
      'quadOut',
      true,
    );
  }

  public fadeOut(): void {
    if (this.alpha === 0) return;
    this.removeTweens();
    const tween = this.tweenTo(
      { alpha: 0, scaleX: PopupRays.initialScale, scaleY: PopupRays.initialScale },
      100,
      'quadOut',
      true,
    );
    tween.onComplete.addOnce(() => {
      this.visible = false;
    });
  }
}
